




























































































































helpers = require('../../helpers.coffee')
voip_locale = require('../../locales/pt_BR.coffee').voip

exports.default =
  components:
    contactAutocomplete: require('../shared/autocomplete/contacts')
    tag: require('../tags/tag')
    lostReasonModal: require('../shared/modals/lost_reason_modal')

  data: ->
    current_user: Session.current_user
    current_company: Session.current_company
    input_number: ''
    phone_number: ''
    status: 'idle'
    show_numbers: false
    muted: false
    show_dialer: false
    fail_reason: ''
    task: new Task()
    phone_number_type: ''
    contact: null
    set_interval: null
    timer: '00:00'
    counter: 0
    sip_authenticated: false
    call_status: 'no_connection'
    started_call: false
    web_rtc_support: true
    show_lost_reason_modal: false
    temp_attr: null

  methods:
    closeLostReasonModal: ->
      @show_lost_reason_modal = false

    updateLostContact: (lost_reason) ->
      attr = {
        stage: 'lost',
        lost_reason_id: lost_reason.id,
        lost_reason_comment: lost_reason.comment,
        send_to_new_flow: lost_reason.send_to_new_flow,
        due_on_date_custom: lost_reason.due_on_date_custom,
        flow: lost_reason.flow,
        immediately: lost_reason.immediately
      }
      attr.status = lost_reason.status if lost_reason.status
      attr.schedule_set_contact_stage = lost_reason.schedule_set_contact_stage if lost_reason.schedule_set_contact_stage
      @updateContact(attr)
      @show_lost_reason_modal = false

    updateContact: (data) ->
      data.id = @contact.id
      @contact_resources.update @updateContactSuccess, @unknownError, data

    updateContactSuccess: () ->
      alertify.success 'Contato atualizado com sucesso!'

    openTaskModalForm: ->
      EventsBus.$emit 'TaskModalForm::Show', { task_id: null, contact: @contact, id: 'dialer-manual-task-form-modal' }

    selectContact: (contact) ->
      @contact = contact

      if contact.telephone
        @updateInputNumber(contact.telephone)
        @phone_number_type = 'telephone'
      else if contact.cellphone
        @updateInputNumber(contact.cellphone)
        @phone_number_type = 'cellphone'

      EventsBus.$emit 'toggle-task-bar', contact.id

    newComment: (open_anyway = false) ->
      @open_anyway = open_anyway
      if @task && @task.id
        @task_resources.get @loadTaskSuccess, @unknownError, id: @task.id
      else
        EventsBus.$emit 'Comment::New', { contact: @contact, template: null }

    loadTaskSuccess: (data) ->
      @task = data.task
      if @task.template.id
        EventsBus.$emit 'Comment::New', { contact: @contact, template: @task.template }
      else if @open_anyway
        EventsBus.$emit 'Comment::New', { contact: @contact, template: null }

    updateInputNumber: (number) ->
      if @input_number
        @input_number += number
      else
        @input_number = @default_country_preffix+number

    saveCallContact: (reset) ->
      voip_call = new VoipCall
      voip_call.id = @plivo.client.getLastCallUUID() if @plivo
      voip_call.status = @call_status
      @voip_call_resources.update @updateStatusSuccess, @unknownError, voip_call
      @close() if !reset

    updateStatusSuccess: ->
      @task.voip_call_status = @call_status
      alertify.success "Status atualizado com sucesso"

    removeTag: (data) ->
      params = { id: @contact.id, contact_tags_attributes: [{ id: data.taggable_tag_id, _destroy: true }] }
      @contact_resources.update @removeTagSuccess(data), @unknownError, params

    removeTagSuccess: (data) ->
      (response) =>
        alertify.success 'Tag removida com sucesso!'
        EventsBus.$emit 'update-tags', data

    updateTags: (data) ->
      @contact.tags = @contact.tags.filter (tag) ->
        tag.taggable_tag_id != data.taggable_tag_id

    openTagsModal: ->
      EventsBus.$emit 'open-tag-picker-modal', @contact

    openContact: (contact_id) ->
      @$router.push('/contatos/'+contact_id)

    toggleTaskBar: ->
      EventsBus.$emit 'toggle-task-bar', @contact.id

    open: (data) ->
      return unless @checkVoipPermissions()
      @contact = data.contact
      @task = data.task if data.task
      @input_number = @default_country_preffix + data.number
      @phone_number_type = data.number_type
      @show_dialer = true
      if @contact
        @$nextTick(() => @$refs.phone_input.focus())
      else
        @$nextTick(() => jQuery('#dialer .v-autocomplete .v-autocomplete-input').focus())
      EventsBus.$emit 'reload-task-bar', @contact.id if @contact
      @newComment(false) if data.open_comment

    reset: (number, phone_type) ->
      @status = 'idle'
      @started_call = false
      @fail_reason = ''
      @timer = '00:00'
      @input_number = @default_country_preffix
      if number
        @input_number = number
        @phone_number_type = phone_type
      else
        @phone_number_type = ''
      @task = new Task
      @saveCallContact(true)

    close: ->
      @hangupCall()
      @muted = false
      @call_status = 'no_connection'
      @show_dialer = false
      @status = 'idle'
      @fail_reason = ''
      @timer = '00:00'
      @contact = null
      @task = new Task
      @input_number = @default_country_preffix

    checkVoipPermissions: ->
      unless @status == 'idle'
        alertify.error(voip_locale.error_messages.ongoing_call)
        return false

      unless Session.current_user.plivo_endpoint && !Session.current_company.isVoipExceeded() && Session.current_company.isPlivo()
        url = 'https://materiaisotb.outboundmarketing.com.br/contratacao-voip'
        window.open(url, '_blank')
        # message = if Session.current_user.isManager() then 'unauthorized_manager' else 'unauthorized'
        # alertify.error(voip_locale.error_messages[message])
        return false

      unless @web_rtc_support
        alertify.error(voip_locale.error_messages.web_rtc_support)
        return false

      unless @sip_authenticated
        alertify.error(voip_locale.error_messages.authentication)
        return false

      unless Plivo?
        alertify.error(voip_locale.error_messages.generic)
        return false

      true

    reloadContact: (contact) ->
      @contact = contact

    goBack: ->
      @show_numbers = false

    setCallStatus: (status) ->
      if status == 'lost'
        @call_status = status
        @temp_attr = { stage: 'lost' }
        @show_lost_reason_modal = true
      else
        @call_status = status


    toggleMute: ->
      return unless @is_calling_on
      @muted = !@muted
      if @muted then @plivo.client.mute() else @plivo.client.unmute()

    startCall: ->
      return if @started_call

      if !@contact
        alertify.error "Por favor selecione um contato."
        return
      @phone_number = @input_number
      @started_call = true
      if @task.id
        @plivo.client.call(helpers.masks.normalizePhone(@phone_number), {'X-PH-TaskId': @task.id})
      else
        @plivo.client.call(helpers.masks.normalizePhone(@phone_number), {'X-PH-ContactId': @contact.id})
      @show_numbers = false

    hangupCall: ->
      @started_call = false
      @status = 'ended'
      @fail_reason = ''
      @show_numbers = false
      @plivo.client.hangup()

    insertPhoneNumber:(number) ->
      @input_number = @input_number + number
      @plivo.client.sendDtmf(number) if @status == 'connected'

    removeLastPhoneNumber: ->
      if @input_number && @input_number.length > 0
        @input_number = @input_number.substring(0, @input_number.length - 1)
      else
        @contact = null
        EventsBus.$emit 'close-task-bar'

    # Time counter methods
    increaseTime: ->
      @timer = moment().hour(0).minute(0).second(@counter++).format('mm:ss')

    startTimer: ->
      @set_interval = setInterval(@increaseTime, 1000)

    stopTimer: ->
      @counter = 0
      clearInterval(@set_interval)

    onPlivoWebrtcNotSupported: ->
      @web_rtc_support = false

    onPlivoLogin: ->
      @sip_authenticated = true

    onPlivoLoginFailed: ->
      @sip_authenticated = false

    onPlivoCallFailed: (error) ->
      console.log '[DEBUG] Dialer: Method: onPlivoCallFailed -> error: '+error
      @started_call = false
      @status = 'failed'
      @fail_reason = error
      @stopTimer()
      @checkMicPermission(error)
      if @fail_reason == 'User Denied Media Access' || @fail_reason == 'Canceled'
        setTimeout((=> @close()), 5000)
      else
        @registerTaskVoipCall()
        @createNewTask()

    onPlivoCallAnswered: (data) ->
      console.log '[DEBUG] Dialer: Method: onPlivoCallAnswered -> data: '+data
      @status = 'connected'
      @startTimer()

    onPlivoCallTerminated: (data) ->
      console.log '[DEBUG] Dialer: Method: onPlivoCallTerminated -> data: '+data
      @started_call = false
      @status = 'ended'
      @stopTimer()
      @registerTaskVoipCall()
      @createNewTask()

    onPlivoCalling: (data) ->
      @status = 'calling'

    onMediaPermission: (data) ->
      console.log('Media Permission:')
      console.log(data)

    registerTaskVoipCall: ->
      EventsBus.$emit 'voip-call-complete', @task

    checkMicPermission: (error) ->
      return unless error == 'User Denied Media Access'
      alertify.error(voip_locale.error_messages.mic_permission)

    initializePlivo: (counter=0) ->
      return unless Session.current_user.plivo_endpoint
      unless Plivo?
        if counter < 200
          setTimeout((=> @initializePlivo(counter + 1)), 50)
        return

      @buildPlivoInstance()
      plivo_credentials = Session.current_user.plivo_endpoint
      @plivo.client.login(plivo_credentials.username, plivo_credentials.password)

    createNewTask: ->
      return if @task.id?
      @task.service = 'ManualTasksServices::Phonecall'
      @task.type =  'ManualTask'
      @task.company = @current_company
      @task.contact = @contact
      @task.assigned_to = @current_user
      @task.assigned_to_id = @current_user.id
      @task.referenceable_id = @contact.id
      @task.referenceable_type = 'Contact'
      @task.created_by = @current_user
      @task.due_on = moment()
      @task.done_at = moment()
      @task.voip_calls_count = 1 # Ensuring that the task can not be undone
      @task.undefined_time = true

      EventsBus.$emit 'Task::Done', @task

    buildPlivoInstance: ->
      @plivo = new Plivo permOnClick: true
      @plivo.client.on('onWebrtcNotSupported', @onPlivoWebrtcNotSupported)
      @plivo.client.on('onLogin', @onPlivoLogin)
      @plivo.client.on('onLoginFailed', @onPlivoLoginFailed)
      @plivo.client.on('onCallFailed', @onPlivoCallFailed)
      @plivo.client.on('onCallAnswered', @onPlivoCallAnswered)
      @plivo.client.on('onCallTerminated', @onPlivoCallTerminated)
      @plivo.client.on('onCalling', @onPlivoCalling)
      @plivo.client.on('onMediaPermission', @onMediaPermission)

  computed:
    dial_css_class: ->
      if @contact
        ""
      else
        "disabled"

    show_contact_button: ->
      @contact?.id?

    show_call_status_options: ->
      console.log '[DEBUG] Dialer: show_call_status_options: '+(@status == "ended" || @status == "failed") && (@fail_reason != "User Denied Media Access" && @fail_reason != "Canceled")
      console.log '[DEBUG] Dialer: Dialer status: '+@status
      console.log '[DEBUG] Dialer: Fail reason: '+@fail_reason
      (@status == "ended" || @status == "failed") && (@fail_reason != "User Denied Media Access" && @fail_reason != "Canceled")

    is_calling_on: ->
      index = @connected_status.indexOf(@status)
      index >= 0

    human_status: ->
      voip_locale.call_status[@status]

    human_fail_reason: ->
      voip_locale.error_messages.failed_status[@fail_reason] || @default_fail_status

    human_number_type: ->
      phone_type = 'Outro número'
      if @phone_number_type == 'cellphone'
        phone_type = 'Celular'
      if @phone_number_type == 'telephone'
        phone_type = 'Fixo'
      phone_type

  watch:
    input_number: (new_value, old_value) ->
      return new_value unless @status == 'idle'
      @input_number = helpers.masks.maskPhone(new_value)

  mounted: ->
    setTimeout((=> @initializePlivo() ), 1000)
    jQuery(window).on('unload', @hangupCall)

  created: ->
    EventsBus.$on 'open-dialer', @open
    EventsBus.$on 'update-contact', @reloadContact
    EventsBus.$on 'update-tags', @updateTags
    @contact_resources = new ContactsResource Session.current_company.id
    @voip_call_resources = new VoipCallsResource Session.current_company.id
    @task_resources = new TasksResource
    @default_country_preffix = '55'
    @possible_status = ['idle', 'calling', 'connected', 'ended', 'failed']
    @connected_status = ['calling','connected']
    @default_fail_status = voip_locale.error_messages.failed_status['Unavailable']
    @$store.dispatch('fetchMeetingTypes') if @$store.getters.meetingTypesCount == 0

  beforeDestroy: ->
    EventsBus.$off 'open-dialer', @open
    EventsBus.$off 'update-tags', @updateTags
    EventsBus.$off 'update-contact', @reloadContact




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/dialer.vue